import React from 'react';
import './EdSiderFindExams.css';

export default function ExamsHeaderTabs({
    showHeader = true,
}) {
    if (!showHeader) return null;

    return (
        <>
            <div className="ed-exams-header">
                <div className="ed-exams-left">
                    <h1 className="ed-exams-title">Exams</h1>
                    <p className="ed-exams-subtitle">Manage your active registrations and explore new testing opportunities.</p>
                </div>
            </div>
        </>
    );
}
